import React, { useEffect } from "react";
import { Card, Table, Layout, PageHeader, Button, Space, Col, Form, Select } from "antd";
import { observer } from "mobx-react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { fmtDateTime } from "../../common/Utils";
import { volunteersStore } from "../../store/volunteer/VolunteersStore";
import { PlusOutlined } from "@ant-design/icons";
import { VolunteerDlg } from "./components/VolunteerDlg";
import { VolunteerCancelDlg } from "./components/VolunteerCancelDlg";
import { RegionFilterBar } from "../../components/filter/RegionFilterBar";
import { SortOrder } from "antd/lib/table/interface";

export const Volunteers = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const store = volunteersStore;

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter, { action }) => {
    console.log("sorter", sorter);
    if (action === "sort") {
      store.sortedInfo = sorter;
      store.refresh();
    }
  };

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Title",
      dataIndex: ["title"],
      key: "title.keyword",
      width: "30%",
      render: (v, r) => <Link to={`/volunteers/${r.id}`}>{v}</Link>,
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "title.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "duration" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "No. of Volunteer",
      key: "stats.confirmed",
      dataIndex: ["stats", "confirmed"],
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "stats.confirmed" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "No. of Hours",
      dataIndex: ["stats", "hours"],
      key: "stats.hours",
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "stats.hours" ? (store.sortedInfo.order as SortOrder) : undefined,
    },

    {
      title: "Create Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: fmtDateTime,
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "createdAt" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Update Time",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: fmtDateTime,
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "updatedAt" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status.keyword",
      sorter: true,
      sortOrder: store.sortedInfo.columnKey === "status.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      key: "actions",
      render: (_, r) => (
        <Space size="middle">
          {["Active", "Scheduled"].includes(r.status) ? (
            <a key="edit" onClick={() => store.editStore.edit(r.id)}>
              Edit
            </a>
          ) : (
            <a key="duplicate" onClick={() => store.editStore.duplicate(r.id)}>
              Duplicate
            </a>
          )}

          {r.needConfirmation && (
            <a key="confirm" onClick={() => history.push(`/volunteers/${r.id}`)}>
              Confirm
            </a>
          )}

          {["Active", "Scheduled"].includes(r.status) && [
            <a key="pause" onClick={() => store.setStatus(r.id, true)}>
              Pause
            </a>,
            <a key="cancel" onClick={() => store.cancelStore.show(r.id, r.schedule)}>
              Cancel
            </a>,
          ]}

          {r.status === "Paused" && (
            <a key="pause" onClick={() => store.setStatus(r.id, false)}>
              Restart
            </a>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content>
      <PageHeader
        title="Volunteers"
        extra={[
          <Button key="new" type="primary" icon={<PlusOutlined />} onClick={() => store.editStore.show()}>
            New Volunteer Proj
          </Button>,
        ]}
      >
        <RegionFilterBar store={store} actionsSpan={8}>
          <Col span={8}>
            <Form.Item label="Status">
              <Select
                style={{ width: "100%" }}
                mode="multiple"
                value={store.filter.status}
                onChange={(e) => {
                  store.filter.status = e;
                  console.log("eee", e);
                }}
              >
                {store.status.map((x: any) => (
                  <Select.Option value={x.id} key={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </RegionFilterBar>
      </PageHeader>

      <div className="padding24" style={{ paddingTop: 0 }}>
        <Card size="small">
          <Table
            size="small"
            pagination={{ ...store.pagination, onChange: onPage }}
            loading={store.loading}
            onChange={onChange}
            rowKey="id"
            columns={columns}
            dataSource={store.data.items}
          />
        </Card>

        {store.editStore.showDlg && <VolunteerDlg />}
        {store.cancelStore.showDlg && <VolunteerCancelDlg />}
      </div>
    </Layout.Content>
  );
});
